import { render, staticRenderFns } from "./POList.vue?vue&type=template&id=45222c13&scoped=true"
import script from "./POList.vue?vue&type=script&lang=js"
export * from "./POList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45222c13",
  null
  
)

export default component.exports